/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  ActivateVanitySubdomainResponse,
  SubdomainAvailabilityResponse,
  UpdateCustomHostnameBody,
  UpdateCustomHostnameResponse,
  VanitySubdomainBody,
  VanitySubdomainConfigResponse
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * @summary [Beta] Gets project's custom hostname config
 */
export type v1GetHostnameConfigResponse200 = {
  data: UpdateCustomHostnameResponse
  status: 200
}

export type v1GetHostnameConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetHostnameConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetHostnameConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetHostnameConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetHostnameConfigResponseSuccess = (v1GetHostnameConfigResponse200) & {
  headers: Headers;
};
export type v1GetHostnameConfigResponseError = (v1GetHostnameConfigResponse401 | v1GetHostnameConfigResponse403 | v1GetHostnameConfigResponse429 | v1GetHostnameConfigResponse500) & {
  headers: Headers;
};

export type v1GetHostnameConfigResponse = (v1GetHostnameConfigResponseSuccess | v1GetHostnameConfigResponseError)

export const getV1GetHostnameConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/custom-hostname`
}

export const v1GetHostnameConfig = async (ref: string, options?: RequestInit): Promise<v1GetHostnameConfigResponse> => {
  
  return customFetch<v1GetHostnameConfigResponse>(getV1GetHostnameConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Deletes a project's custom hostname configuration
 */
export type v1DeleteHostnameConfigResponse200 = {
  data: void
  status: 200
}

export type v1DeleteHostnameConfigResponse401 = {
  data: void
  status: 401
}

export type v1DeleteHostnameConfigResponse403 = {
  data: void
  status: 403
}

export type v1DeleteHostnameConfigResponse429 = {
  data: void
  status: 429
}

export type v1DeleteHostnameConfigResponse500 = {
  data: void
  status: 500
}

export type v1DeleteHostnameConfigResponseSuccess = (v1DeleteHostnameConfigResponse200) & {
  headers: Headers;
};
export type v1DeleteHostnameConfigResponseError = (v1DeleteHostnameConfigResponse401 | v1DeleteHostnameConfigResponse403 | v1DeleteHostnameConfigResponse429 | v1DeleteHostnameConfigResponse500) & {
  headers: Headers;
};

export type v1DeleteHostnameConfigResponse = (v1DeleteHostnameConfigResponseSuccess | v1DeleteHostnameConfigResponseError)

export const getV1DeleteHostnameConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/custom-hostname`
}

export const v1DeleteHostnameConfig = async (ref: string, options?: RequestInit): Promise<v1DeleteHostnameConfigResponse> => {
  
  return customFetch<v1DeleteHostnameConfigResponse>(getV1DeleteHostnameConfigUrl(ref),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary [Beta] Updates project's custom hostname configuration
 */
export type v1UpdateHostnameConfigResponse201 = {
  data: UpdateCustomHostnameResponse
  status: 201
}

export type v1UpdateHostnameConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdateHostnameConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdateHostnameConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdateHostnameConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdateHostnameConfigResponseSuccess = (v1UpdateHostnameConfigResponse201) & {
  headers: Headers;
};
export type v1UpdateHostnameConfigResponseError = (v1UpdateHostnameConfigResponse401 | v1UpdateHostnameConfigResponse403 | v1UpdateHostnameConfigResponse429 | v1UpdateHostnameConfigResponse500) & {
  headers: Headers;
};

export type v1UpdateHostnameConfigResponse = (v1UpdateHostnameConfigResponseSuccess | v1UpdateHostnameConfigResponseError)

export const getV1UpdateHostnameConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/custom-hostname/initialize`
}

export const v1UpdateHostnameConfig = async (ref: string,
    updateCustomHostnameBody: UpdateCustomHostnameBody, options?: RequestInit): Promise<v1UpdateHostnameConfigResponse> => {
  
  return customFetch<v1UpdateHostnameConfigResponse>(getV1UpdateHostnameConfigUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCustomHostnameBody,)
  }
);}
  

/**
 * @summary [Beta] Attempts to verify the DNS configuration for project's custom hostname configuration
 */
export type v1VerifyDnsConfigResponse201 = {
  data: UpdateCustomHostnameResponse
  status: 201
}

export type v1VerifyDnsConfigResponse401 = {
  data: void
  status: 401
}

export type v1VerifyDnsConfigResponse403 = {
  data: void
  status: 403
}

export type v1VerifyDnsConfigResponse429 = {
  data: void
  status: 429
}

export type v1VerifyDnsConfigResponse500 = {
  data: void
  status: 500
}

export type v1VerifyDnsConfigResponseSuccess = (v1VerifyDnsConfigResponse201) & {
  headers: Headers;
};
export type v1VerifyDnsConfigResponseError = (v1VerifyDnsConfigResponse401 | v1VerifyDnsConfigResponse403 | v1VerifyDnsConfigResponse429 | v1VerifyDnsConfigResponse500) & {
  headers: Headers;
};

export type v1VerifyDnsConfigResponse = (v1VerifyDnsConfigResponseSuccess | v1VerifyDnsConfigResponseError)

export const getV1VerifyDnsConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/custom-hostname/reverify`
}

export const v1VerifyDnsConfig = async (ref: string, options?: RequestInit): Promise<v1VerifyDnsConfigResponse> => {
  
  return customFetch<v1VerifyDnsConfigResponse>(getV1VerifyDnsConfigUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary [Beta] Activates a custom hostname for a project.
 */
export type v1ActivateCustomHostnameResponse201 = {
  data: UpdateCustomHostnameResponse
  status: 201
}

export type v1ActivateCustomHostnameResponse401 = {
  data: void
  status: 401
}

export type v1ActivateCustomHostnameResponse403 = {
  data: void
  status: 403
}

export type v1ActivateCustomHostnameResponse429 = {
  data: void
  status: 429
}

export type v1ActivateCustomHostnameResponse500 = {
  data: void
  status: 500
}

export type v1ActivateCustomHostnameResponseSuccess = (v1ActivateCustomHostnameResponse201) & {
  headers: Headers;
};
export type v1ActivateCustomHostnameResponseError = (v1ActivateCustomHostnameResponse401 | v1ActivateCustomHostnameResponse403 | v1ActivateCustomHostnameResponse429 | v1ActivateCustomHostnameResponse500) & {
  headers: Headers;
};

export type v1ActivateCustomHostnameResponse = (v1ActivateCustomHostnameResponseSuccess | v1ActivateCustomHostnameResponseError)

export const getV1ActivateCustomHostnameUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/custom-hostname/activate`
}

export const v1ActivateCustomHostname = async (ref: string, options?: RequestInit): Promise<v1ActivateCustomHostnameResponse> => {
  
  return customFetch<v1ActivateCustomHostnameResponse>(getV1ActivateCustomHostnameUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary [Beta] Gets current vanity subdomain config
 */
export type v1GetVanitySubdomainConfigResponse200 = {
  data: VanitySubdomainConfigResponse
  status: 200
}

export type v1GetVanitySubdomainConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetVanitySubdomainConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetVanitySubdomainConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetVanitySubdomainConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetVanitySubdomainConfigResponseSuccess = (v1GetVanitySubdomainConfigResponse200) & {
  headers: Headers;
};
export type v1GetVanitySubdomainConfigResponseError = (v1GetVanitySubdomainConfigResponse401 | v1GetVanitySubdomainConfigResponse403 | v1GetVanitySubdomainConfigResponse429 | v1GetVanitySubdomainConfigResponse500) & {
  headers: Headers;
};

export type v1GetVanitySubdomainConfigResponse = (v1GetVanitySubdomainConfigResponseSuccess | v1GetVanitySubdomainConfigResponseError)

export const getV1GetVanitySubdomainConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/vanity-subdomain`
}

export const v1GetVanitySubdomainConfig = async (ref: string, options?: RequestInit): Promise<v1GetVanitySubdomainConfigResponse> => {
  
  return customFetch<v1GetVanitySubdomainConfigResponse>(getV1GetVanitySubdomainConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Deletes a project's vanity subdomain configuration
 */
export type v1DeactivateVanitySubdomainConfigResponse200 = {
  data: void
  status: 200
}

export type v1DeactivateVanitySubdomainConfigResponse401 = {
  data: void
  status: 401
}

export type v1DeactivateVanitySubdomainConfigResponse403 = {
  data: void
  status: 403
}

export type v1DeactivateVanitySubdomainConfigResponse429 = {
  data: void
  status: 429
}

export type v1DeactivateVanitySubdomainConfigResponse500 = {
  data: void
  status: 500
}

export type v1DeactivateVanitySubdomainConfigResponseSuccess = (v1DeactivateVanitySubdomainConfigResponse200) & {
  headers: Headers;
};
export type v1DeactivateVanitySubdomainConfigResponseError = (v1DeactivateVanitySubdomainConfigResponse401 | v1DeactivateVanitySubdomainConfigResponse403 | v1DeactivateVanitySubdomainConfigResponse429 | v1DeactivateVanitySubdomainConfigResponse500) & {
  headers: Headers;
};

export type v1DeactivateVanitySubdomainConfigResponse = (v1DeactivateVanitySubdomainConfigResponseSuccess | v1DeactivateVanitySubdomainConfigResponseError)

export const getV1DeactivateVanitySubdomainConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/vanity-subdomain`
}

export const v1DeactivateVanitySubdomainConfig = async (ref: string, options?: RequestInit): Promise<v1DeactivateVanitySubdomainConfigResponse> => {
  
  return customFetch<v1DeactivateVanitySubdomainConfigResponse>(getV1DeactivateVanitySubdomainConfigUrl(ref),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary [Beta] Checks vanity subdomain availability
 */
export type v1CheckVanitySubdomainAvailabilityResponse201 = {
  data: SubdomainAvailabilityResponse
  status: 201
}

export type v1CheckVanitySubdomainAvailabilityResponse401 = {
  data: void
  status: 401
}

export type v1CheckVanitySubdomainAvailabilityResponse403 = {
  data: void
  status: 403
}

export type v1CheckVanitySubdomainAvailabilityResponse429 = {
  data: void
  status: 429
}

export type v1CheckVanitySubdomainAvailabilityResponse500 = {
  data: void
  status: 500
}

export type v1CheckVanitySubdomainAvailabilityResponseSuccess = (v1CheckVanitySubdomainAvailabilityResponse201) & {
  headers: Headers;
};
export type v1CheckVanitySubdomainAvailabilityResponseError = (v1CheckVanitySubdomainAvailabilityResponse401 | v1CheckVanitySubdomainAvailabilityResponse403 | v1CheckVanitySubdomainAvailabilityResponse429 | v1CheckVanitySubdomainAvailabilityResponse500) & {
  headers: Headers;
};

export type v1CheckVanitySubdomainAvailabilityResponse = (v1CheckVanitySubdomainAvailabilityResponseSuccess | v1CheckVanitySubdomainAvailabilityResponseError)

export const getV1CheckVanitySubdomainAvailabilityUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/vanity-subdomain/check-availability`
}

export const v1CheckVanitySubdomainAvailability = async (ref: string,
    vanitySubdomainBody: VanitySubdomainBody, options?: RequestInit): Promise<v1CheckVanitySubdomainAvailabilityResponse> => {
  
  return customFetch<v1CheckVanitySubdomainAvailabilityResponse>(getV1CheckVanitySubdomainAvailabilityUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vanitySubdomainBody,)
  }
);}
  

/**
 * @summary [Beta] Activates a vanity subdomain for a project.
 */
export type v1ActivateVanitySubdomainConfigResponse201 = {
  data: ActivateVanitySubdomainResponse
  status: 201
}

export type v1ActivateVanitySubdomainConfigResponse401 = {
  data: void
  status: 401
}

export type v1ActivateVanitySubdomainConfigResponse403 = {
  data: void
  status: 403
}

export type v1ActivateVanitySubdomainConfigResponse429 = {
  data: void
  status: 429
}

export type v1ActivateVanitySubdomainConfigResponse500 = {
  data: void
  status: 500
}

export type v1ActivateVanitySubdomainConfigResponseSuccess = (v1ActivateVanitySubdomainConfigResponse201) & {
  headers: Headers;
};
export type v1ActivateVanitySubdomainConfigResponseError = (v1ActivateVanitySubdomainConfigResponse401 | v1ActivateVanitySubdomainConfigResponse403 | v1ActivateVanitySubdomainConfigResponse429 | v1ActivateVanitySubdomainConfigResponse500) & {
  headers: Headers;
};

export type v1ActivateVanitySubdomainConfigResponse = (v1ActivateVanitySubdomainConfigResponseSuccess | v1ActivateVanitySubdomainConfigResponseError)

export const getV1ActivateVanitySubdomainConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/vanity-subdomain/activate`
}

export const v1ActivateVanitySubdomainConfig = async (ref: string,
    vanitySubdomainBody: VanitySubdomainBody, options?: RequestInit): Promise<v1ActivateVanitySubdomainConfigResponse> => {
  
  return customFetch<v1ActivateVanitySubdomainConfigResponse>(getV1ActivateVanitySubdomainConfigUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      vanitySubdomainBody,)
  }
);}
  

